import React, { useState, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";

import ReactLoading from 'react-loading';
import CourbeService from '../components/CourbeService/CourbeService.js'
import OpSelect from '../components/CourbeService/OpSelect.js'
import optc from '../optc.json'

import { getHistory, getGroups, getUserAgency } from '../API.js';

// date-time config
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
const tz = "America/Toronto"
dayjs.extend(utc);
dayjs.extend(timezone);

import { useTranslation } from "react-i18next";

function ReelPlanif() {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  const [day, setDay] = useState('');
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedDayFormat, setSelectedDayFormat] = useState(null);
  const [todayFormat, setTodayFormat] = useState(null);

  const [vehDataRealtime, setVehDataRealtime] = useState(null);
  const [vehDataPlanned, setVehDataPlanned] = useState(null);

  const [userAgency, setUserAgency] = useState('');
  const [groups, setGroups] = useState('');
  const [prevGroups, setPrevGroups] = useState('');

  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {

    let today = new Date();

    const date = day ? day : today;

    getUserAgency().then((userAgency) => {

      getGroups().then((groups) => {
        groups = groups.filter((e) => optc.optc.some((f) => f.groupe == e.groupe));

        if (prevGroups !== '') {
          groups.forEach((e) => {
            if (prevGroups.find((f) => { return e.groupe == f.groupe }).active == true) {
              e.active = true
            } else {
              e.active = false
            }
          })
        } else {
          if (userAgency == 'admin') {
            groups.forEach((e) => {
              if (e.groupe == 'stm') {
                e.active = true
              } else {
                e.active = false
              }
            })
          } else {
            groups.forEach((e) => {
              if (e.groupe == optc.optc.find((e) => e.operateur == userAgency[0]).groupe) {
                e.active = true
              } else {
                e.active = false
              }
            })
          }
        }

        const parseAllR = [];
        const parseAllP = [];

        let previous = dayjs(date).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD') ? 0 : 1;

        const allVehicles = getHistory(date, previous).then((result) => {

          result.forEach((e) => {
            const agency = optc.optc.find((f) => f.groupe == e.groupe);
            if (!agency) return;

            let timezone = agency.timezone;
            let timeFormat = '';

            if (parseInt(e.timestr.substring(0, 2)) >= 0 && parseInt(e.timestr.substring(0, 2)) < 4) {
              timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).add(1, 'day').tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
            } else {
              timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
            }

            let timeFormatTZ = dayjs(timeFormat).valueOf();

            // Convert hh:mm:ss to unix milliseconds
            // Format required by recharts for time series
            parseAllR.push({
              time: timeFormatTZ,
              veh: Number(e.veh),
              operateur: e.reseau,
              groupe: e.groupe,
            })
          })

          result.forEach((e) => {
            const agency = optc.optc.find((f) => f.groupe == e.groupe);
            if (!agency) return;

            let timezone = agency.timezone;
            let timeFormat = '';

            if (parseInt(e.timestr.substring(0, 2)) >= 0 && parseInt(e.timestr.substring(0, 2)) < 4) {
              timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).add(1, 'day').tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
            } else {
              timeFormat = (e.groupe, e.timestr, dayjs("2019-04-28 " + e.timestr).tz(timezone).format("YYYY-MM-DD HH:mm:ss"));
            }

            let timeFormatTZ = dayjs(timeFormat).valueOf();

            parseAllP.push({
              //timestr : e.timestr,
              time: timeFormatTZ,
              //time: e.timeunix,
              veh: e.planned,
              groupe: e.groupe,
              operateur: e.reseau
              // rid: e.rid
            })
          })

          const vehDataRealtime = [];
          groups.forEach((a) => {
            vehDataRealtime.push({
              operateur: a.groupe,
              data: parseAllR.filter((e) => { return e.groupe === a.groupe })
            })
          })

          const vehDataPlanned = [];
          groups.forEach((a) => {
            vehDataPlanned.push({
              operateur: a.groupe,
              data: parseAllP.filter((e) => { return e.groupe === a.groupe })
            })
          })

          let todayFormat = formatDate(today);
          let selectedDayFormat = day ? formatDate(day) : todayFormat;

          setGroups(groups);
          setSelectedDay(date);
          setTodayFormat(todayFormat);
          setSelectedDayFormat(selectedDayFormat);
          setVehDataRealtime(vehDataRealtime);
          setVehDataPlanned(vehDataPlanned);
          setUserAgency(userAgency);

        });

      })
    })

  }, [refreshKey])

  function formatDate(dayToFormat) {
    let dd = String(dayToFormat.getDate()).padStart(2, '0');
    let mm = String(dayToFormat.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = dayToFormat.getFullYear();

    let result = yyyy + '-' + mm + '-' + dd;
    return result
  }

  const handleDayClick = (day) => {
    setVehDataRealtime([]);
    setPrevGroups(groups);
    setDay(day);
    setRefreshKey(oldKey => oldKey + 1);
  }

  const handleToggleOp = (e) => {

    let groupList = [...groups];

    let groupSelected = groupList.find((f) => { return f.groupe == e.target.innerHTML });

    if (groupSelected.active == false) {
      groupList.find((f) => { return f.groupe == e.target.innerHTML }).active = true
    } else {
      groupList.find((f) => { return f.groupe == e.target.innerHTML }).active = false
    }

    setGroups(groupList);

  }

  return vehDataRealtime && vehDataRealtime.length > 0 && selectedDay && userAgency ? (
    <React.Fragment>

      <div className="row ps-1 pe-1">
        <div className="col-sm">
          <h1 id="page-title" className="display-5">{t('plancurve.title')}</h1>
        </div>
      </div>

      <div className="container" style={{ backgroundColor: "#f8f9fa" }}>

        <div className="d-flex justify-content-center pt-3">
          <DatePicker
            selected={selectedDay}
            onChange={(date) => handleDayClick(date)}
            locale={i18n.language.substring(0,2)=='fr'?fr:en}
            inline
            excludeDateIntervals={[
              {
                start: subDays(new Date('2000-01-01'), 0),
                end: addDays(new Date('2023-07-01'), 0)
              },
              {
                start: subDays(new Date(), 0),
                end: addDays(new Date('2030-12-31'), 0)
              },
            ]}
          />
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-6 text-center pb-3 pt-3">
            <OpSelect
              groups={groups}
              handleToggle={handleToggleOp}
              properties={optc.optc}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm text-center pt-2">
            <h4>{selectedDayFormat}</h4>
          </div>
        </div>

        <div className="row" >
          {groups.map((a) => (
            a.active == true ?
              <div className="col-lg-4 col-sm-12 pb-2 pt-2" key={a.groupe}>
                <div className="ms-1 me-1 border rounded" style={{ backgroundColor: "white" }}>
                  <CourbeService
                    key={a.groupe}
                    realtimeData={vehDataRealtime.find(f => f.operateur === a.groupe).data}
                    plannedData={vehDataPlanned.find(f => f.operateur === a.groupe).data}
                    color={optc.optc.find((e) => e.groupe == a.groupe).color}
                    groupe={a.groupe}
                  />
                </div>
              </div> : ""
          ))}
        </div>
      </div>
    </React.Fragment>
  ) :
    <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
    </div>
}


export default ReelPlanif;
